import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/i18n/translations";
import { extra } from "@/i18n/translationsExtra";

const LanguageContext = createContext(null);

function deepMerge(a, b) {
  const out = { ...a };
  for (const k of Object.keys(b || {})) {
    if (b[k] && typeof b[k] === "object" && !Array.isArray(b[k])) {
      out[k] = deepMerge(a?.[k] || {}, b[k]);
    } else {
      out[k] = b[k];
    }
  }
  return out;
}

const MERGED = {
  fr: deepMerge(translations.fr, extra.fr),
  nl: deepMerge(translations.nl, extra.nl),
  en: deepMerge(translations.en, extra.en),
};

const dig = (dict, key) =>
  key.split(".").reduce((o, k) => (o && o[k] != null ? o[k] : undefined), dict);

const detectBrowserLang = () => {
  const nav = (navigator.language || navigator.userLanguage || "fr").slice(0, 2).toLowerCase();
  return ["fr", "nl", "en"].includes(nav) ? nav : "fr";
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("gts_lang") || detectBrowserLang());

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const change = (l) => {
    localStorage.setItem("gts_lang", l);
    setLang(l);
  };

  const t = (key, vars) => {
    let val = dig(MERGED[lang] || {}, key);
    if (val == null) val = dig(MERGED.fr, key);
    if (val == null) return key;
    if (vars && typeof val === "string") {
      Object.entries(vars).forEach(([k, v]) => {
        val = val.replace(new RegExp(`\\{${k}\\}`, "g"), v);
      });
    }
    return val;
  };

  const tf = (key, fallback) => { const v = t(key); return v === key ? (fallback ?? "") : v; };

  return (
    <LanguageContext.Provider value={{ lang, setLang: change, t, tf }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
